import { render, staticRenderFns } from "./RegistrationBadge.vue?vue&type=template&id=016deb3d&"
import script from "./RegistrationBadge.vue?vue&type=script&lang=ts&"
export * from "./RegistrationBadge.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports